var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1719107383697,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 12018,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M209.322667 128a42.368 42.368 0 0 0-41.301334 52.010667c0.298667 1.322667 32 137.984 32 288 0 144.981333-109.653333 364.501333-110.677333 366.677333a42.154667 42.154667 0 0 0 2.645333 41.301333c7.68 12.672 21.162667 20.010667 36.010667 20.010667h449.322667C830.165333 896 938.666667 554.837333 938.666667 446.677333c0-102.656-53.674667-280.490667-56.021334-288A43.605333 43.605333 0 0 0 841.386667 128z m106.666666 213.333333H425.386667c106.837333 0 107.989333 85.845333 107.989333 102.656 0 70.997333-41.685333 91.861333-49.322667 96l59.989334 138.666667V682.666667h-73.344l-52.010667-125.354667H384V682.666667H315.989333z m237.354667 0h237.312v57.344h-83.968V682.666667h-69.333333V398.677333h-84.053334zM384 398.677333v101.333334h40.021333c36.821333 0 41.301333-34.005333 41.301334-49.322667 0-7.850667-0.64-52.053333-39.978667-52.053333z",
    fill: "#333",
    "p-id": 12019
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRt);
export default __webpack_public_path__ + "static/media/rt.9f534b003f636d9c691490e17bc4b303.svg";
export { ForwardRef as ReactComponent };